import { Input } from "antd";
import { FunctionComponent } from "react";
import { useSearchParams } from "react-router-dom";
interface FilterData {
  from?: string;
  to?: string;
  name?: string;
  url?: string;
}

interface ListFilterProps {
  loading?: boolean;
}

const ListFilter: FunctionComponent<ListFilterProps> = ({ loading }) => {
  const [, setSearch] = useSearchParams();

  const onSearch = (query: string) => {
    setSearch({ query });
  };

  return (
    <Input.Search
      loading={loading}
      placeholder="input search text"
      onSearch={onSearch}
      enterButton
      allowClear
    />
  );
};

export default ListFilter;
